type PlusIconProps = React.SVGProps<SVGSVGElement>;

const PlusIcon: React.FC<PlusIconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    {...props}
  >
    <path
      d="M19 13.6895H13V19.6895H11V13.6895H5V11.6895H11V5.68945H13V11.6895H19V13.6895Z"
      fill="currentColor"
    />
  </svg>
);

export default PlusIcon;
